import { Autocomplete, CircularProgress, IconButton, TextField } from "@mui/material";
import { Component } from "react";
import CenteredMessage from "./CenteredMessage";
import RefreshIcon from '@mui/icons-material/Refresh';


/**
 * @param {object} props
 * @param {function} props.fetchData - Function to fetch data.
 * @param {function} props.renderOption - Function to render each option in the Autocomplete.
 * @param {function} props.transformOption - Function to transform each option before rendering.
 * @param {function} props.onChange - Callback function when an option is selected.
 * @param {string} props.id - The id of the Autocomplete component.
 * @param {string} props.size - The size of the Autocomplete component.
 * @param {string} props.label - The label for the TextField component.
 * @param {string} props.variant - The variant for the TextField component.
 * @param {string} props.className - Additional class names for the root div.
 * @param {string} props.value - The current value of the Autocomplete component.
 * @param {string} props.dataNotFetchedMessage - Message to display when data is not fetched.
 * @param {string} props.emptyStateMessage - Message to display when no data is found.
 * @param {boolean} props.disabled
 */
export default class SearchItem extends Component {

   state = {
      data: null,
      loading: false,
   }

   fetchData = async () => {
      try {
         this.setState({ loading: true });
         const data = await this.props.fetchData();
         this.setState({ data });

         if (typeof this.props.onDataFetched === 'function')
            this.props.onDataFetched(data);

      } catch (err) {
         console.error(err);
      } finally {
         this.setState({ loading: false });
      }
   }

   componentDidMount() {
      if (this.props.cachedData)
         this.setState({ data: this.props.cachedData });
      else
         this.fetchData();
   }

   render() {

      const { loading, data } = this.state;
      let renderOption, options;
      const { transformOption } = this.props;

      if (loading) {
         options = [ 1 ];

         renderOption = () => <div className="flex justify-center items-center h-[150px]">
            <CircularProgress />
         </div>

      } else if (data?.length > 0) {
         options = data;
         if (typeof transformOption === 'function')
            options = data.map(transformOption);

         renderOption = this.props.renderOption;
      } else {
         options = [ 1 ];
         let message

         if (data === null) {
            message = this.props.dataNotFetchedMessage || "Data not fetched";
         } else {
            message = this.props.emptyStateMessage || "No data found in the system";
         }

         renderOption = () => <div className="flex justify-center items-center h-[150px]">
            <CenteredMessage
               message={message}
               onRefresh={this.fetchData}
            />
         </div>
      }

      let value = this.props.value || '';

      if (value && (typeof value !== 'string' || typeof value?.label !== 'string')) {
         if (typeof transformOption === 'function')
            value = transformOption(value);
      }

      return <div className={`w-full ${this.props.className}`}>
         <div className="grid grid-cols-[1fr,auto] gap-2">
            <Autocomplete
               id={this.props.id}
               size={this.props.size}
               renderInput={params => <TextField
                  label={this.props.label}
                  variant={this.props.variant}
                  {...params}
               />}
               options={options}
               renderOption={renderOption}
               fullWidth
               onChange={(_, item) => this.props.onChange(item)}
               value={value}
               disabled={this.props.disabled}
            />
            {
               !this.props.hideRefreshButton && <IconButton onClick={this.fetchData} disabled={loading}>
                  <RefreshIcon />
               </IconButton>
            }
         </div>
      </div>
   }

}